import { Box, ButtonDropdown, Icon } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';
import globeIcon from '../../assets/globe.svg';
import { SUPPORTED_LOCALES, DEFAULT_LOCALE } from '../../util/locale';

export const LocaleMenu = () => {
    const { i18n } = useTranslation();

    const currentLocale =
        SUPPORTED_LOCALES.find((locale) => i18n.language.startsWith(locale.id.split('-')[0])) || DEFAULT_LOCALE;

    return (
        <ButtonDropdown
            items={SUPPORTED_LOCALES}
            data-testid="header-localeMenu"
            onItemClick={({ detail }) => {
                i18n.changeLanguage(detail.id);
            }}
        >
            <Box margin={{ right: 'xs' }} display="inline">
                <Icon url={globeIcon} alt="" />
            </Box>
            {currentLocale.text}
        </ButtonDropdown>
    );
};
